// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".celda-vertical{-ms-writing-mode:tb-rl;writing-mode:vertical-rl;font-family:Calibri,serif;font-size:small;transform:rotate(180deg);height:-webkit-fit-content;height:-moz-fit-content;height:fit-content}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
